import Link from 'next/link'
import { Fragment, type ReactNode } from 'react'
import type { Author } from '@/payload-types'

/**
 * Byline articolo: «di Autore · data · N min di lettura». Inserisce il separatore
 * SOLO tra le parti effettivamente presenti, eliminando la catena di condizioni
 * separatore duplicata in card e testata. Il separatore eredita il colore dal
 * contenitore (opacity), così la stessa byline funziona su sfondo chiaro e scuro.
 */
export function PostMeta({
  author,
  dateISO,
  dateLabel,
  readingTime,
  linkAuthor = false,
  className = '',
}: {
  author: Author | null
  dateISO?: string | null
  dateLabel?: string | null
  readingTime?: number | null
  linkAuthor?: boolean
  className?: string
}) {
  const parts: ReactNode[] = []

  if (author) {
    parts.push(
      linkAuthor && author.slug ? (
        <Link href={`/autore/${author.slug}/`} className="transition-colors hover:text-accent-strong">
          di {author.name}
        </Link>
      ) : (
        <span>di {author.name}</span>
      ),
    )
  }
  if (dateLabel) parts.push(<time dateTime={dateISO ?? undefined}>{dateLabel}</time>)
  if (readingTime) parts.push(<span>{readingTime} min di lettura</span>)

  if (!parts.length) return null

  return (
    <div className={className}>
      {parts.map((part, i) => (
        <Fragment key={i}>
          {i > 0 ? (
            <span aria-hidden className="opacity-40">
              ·
            </span>
          ) : null}
          {part}
        </Fragment>
      ))}
    </div>
  )
}
